import classnames from 'classnames';

interface Props {
  children: string;
  center?: boolean;
  for: string;
  hidden?: boolean;
  id?: string;
}

const Label = ({
  children,
  center = false,
  for: For,
  hidden = false,
  id = undefined,
}: Props) => {
  const className = classnames({
    hidden: hidden,
    'text-label-color': true,
    'pb-1': true,
    block: center,
    'text-center': center,
  });

  return (
    <label id={id} hidden={hidden} htmlFor={For} className={className}>
      {children}
    </label>
  );
};

export default Label;
